/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packing_List_Col_Carton_RefInputs */

const en_packing_list_col_carton_ref = /** @type {(inputs: Packing_List_Col_Carton_RefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carton`)
};

/**
* | output |
* | --- |
* | "Carton" |
*
* @param {Packing_List_Col_Carton_RefInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const packing_list_col_carton_ref = /** @type {((inputs?: Packing_List_Col_Carton_RefInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packing_List_Col_Carton_RefInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_packing_list_col_carton_ref(inputs)
});